import React from 'react';
// FA6 subset: only the 25 icons used on public pages (~3KB vs 74KB full)
import './css/fa-public-subset.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './public_pages/Landing';
import Landing2026Funnel2 from './public_pages/Landing2026Funnel2';
import Knowledge from './public_pages/Knowledge';
import Articles from './public_pages/Articles';

/** Full page load: paths under /app are served by a different bundle (see index.tsx). */
const RedirectToApp: React.FC<{ path: string }> = ({ path }) => {
  React.useEffect(() => {
    window.location.replace(`/app${path}`);
  }, [path]);
  return null;
};

const PublicApp: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/landing-legacy" element={<Landing />} />
        <Route path="/" element={<Landing2026Funnel2 />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/delete-account" element={<RedirectToApp path="/public/delete-account" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default PublicApp;

